import { PolymorphicComponent } from "styled-components";
import { LoadingIcon } from "../../materials/icons/loading-icon/LoadingIcon";
import {
  Button as ButtonBase,
  LoadingButton,
  LoadingIconWrapper,
  Props,
} from "./Button.Parts";

export const Button = (({ loading, disabled, children, ...rest }: Props) => {
  if (loading)
    return (
      <LoadingButton
        {...rest}
        disabled={disabled || "functional"}
        $overlay={typeof loading !== "string"}
        aria-busy={true}
      >
        <LoadingIconWrapper>
          <LoadingIcon aria-hidden={true} focusable={false} />
          {loading}
        </LoadingIconWrapper>
        <span>{children}</span>
      </LoadingButton>
    );

  return (
    <ButtonBase {...rest} disabled={disabled}>
      {children}
    </ButtonBase>
  );
}) as PolymorphicComponent<"web", Props>;
